import { Dispatch } from "@reduxjs/toolkit";
import { apiPost } from "./generic.api";

export const sendAudioToSTT = async (
  dispatch: Dispatch,
  data: FormData,
): Promise<any> => {
  return (
    (await apiPost<{ body: any }, FormData>(
      dispatch,
      `api/stt`,
      data,
      "multipart/form-data",
    )) || []
  );
};
